// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerText_root__m_EVj"};